// TODO: рефактор из-за web components и rootNode

// получение позиции элемента относительно страницы
const getTopPosition = (element: HTMLElement, offset: number = 0): number => {
  if (!element) {
    return 0;
  }

  return element.getBoundingClientRect().top + window.scrollY - offset;
};

// функция скролла
const scrollToElement = (element: HTMLElement, offset: number = 0, behavior: ScrollBehavior = 'smooth') => {
  // Нужен timeout чтобы позиция успела измениться, и подхватили реальный отступ
  const position = getTopPosition(element, offset);
  window.scrollTo({ top: position, behavior });
};

export const filterScroll = (rootNode: ShadowRoot | null, isReset = false, isRubricsExperimentActive = false) => {
  if (!rootNode) {
    return;
  }

  const listingElement = rootNode.getElementById('all-cards') as HTMLElement | null;
  const filtersElement = rootNode.querySelector('.filters-line') as HTMLElement | null;
  const smallOutput = rootNode.querySelector('.small-output-wrapper') as HTMLElement | null;
  const rubricsElement = rootNode.querySelector('.rubrics-wrapper') as HTMLLinkElement | null;

  if (isReset) {
    scrollToTop();

    return;
  }

  if (!listingElement || !filtersElement) {
    return;
  }

  // Проверяем, если фильтры находятся выше блоков сортировки
  const filtersTop = getTopPosition(filtersElement);
  const listingTop = getTopPosition(listingElement);

  // Если фильтры выше — не скроллим. Только для сброса
  if (filtersTop < listingTop && isReset) {
    return;
  }

  // На мобиле у фильтров появился паддинг, который не учитывается в скролле.
  let offset = filtersElement.offsetHeight;

  if (smallOutput) {
    offset += parseInt(window.getComputedStyle(smallOutput).marginTop, 10);
  }

  const elementToScroll = smallOutput ?? listingElement;

  if (isRubricsExperimentActive && rubricsElement) {
    /**
     * если это мобила + активный эксперимент с рубриками - скролим до начала рубрик
     */
    scrollToElement(rubricsElement, offset);
  } else {
    scrollToElement(elementToScroll, offset); // Скроллим до элемента с учетом отступа
  }
};

export const sortingScroll = (rootNode: ShadowRoot | null, isBigDefaultOffset?: boolean) => {
  if (!rootNode) {
    return;
  }

  const listingElement = rootNode.querySelector('#all-cards') as HTMLElement | null;
  const filtersElement = rootNode.querySelector('.filters-line_scroll') as HTMLElement | null;
  const filtersMobileElement = rootNode.querySelector('.filters-line_scroll-mobile') as HTMLElement | null;
  const smallOutput = rootNode.querySelector('.small-output-wrapper') as HTMLElement | null;

  if (!listingElement) {
    return;
  }

  const defaultOffset = isBigDefaultOffset ? 120 : 48;

  const offset = filtersElement?.offsetHeight ?? filtersMobileElement?.offsetHeight ?? defaultOffset;
  const elementToScroll = smallOutput ?? listingElement;

  scrollToElement(elementToScroll, offset); // Скроллим до элемента с учетом отступа
};

export const paginationScroll = (rootNode: ShadowRoot | null) => {
  if (!rootNode) {
    return;
  }

  const listingElement = rootNode.querySelector('.cards-block__count-sorting') as HTMLElement | null;
  const filtersElement = rootNode.querySelector('.filters-line') as HTMLElement | null;

  if (!listingElement || !filtersElement) {
    return;
  }

  const offset = filtersElement.offsetHeight;

  scrollToElement(listingElement, offset); // Скроллим до элемента с учетом отступа
};

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};
